import React, { Component, Fragment } from 'react'
import { Button, Form, FormControl, Row, Col, FormGroup, ControlLabel } from 'react-bootstrap'
import axios from 'axios'
import { end_point, getParams, makeUniqueKey } from './helper'
import TransactionDetails from './TransactionDetails'
import PricingDetails from './PricingDetails'

// Two step process #1 Get Token  #2 Submit Refund
class Refund extends Component {
  constructor(props) {
    super(props)
    this.state = {
      token: null,
      disable: false, 
      nextButtonDisable: false,
      result: null,
      resultMessage: null,
      next_spinner: false,
      submit_spinner: false,
      jwt: getParams().jwt
    }
  }

  cancelRefund = () => {
    this.setState({
      token: null,
      disable: false
    })
  }
  
  handleSubmit = async () => {
    
    this.setState({submit_spinner: true })
    var rthis = this // static 'hoopstir' this to be used in sdk
    var resultFunctions = {
      onError: (error) => {
        console.log("On Error", error)
        rthis.setState({
          result: "Error", 
          resultMessage: JSON.stringify(error), 
          submit_spinner: false
        })
      },
      onDeclined: (response) => {
        console.log("On Declined", response)
        rthis.setState({
          result: "Declined", 
          resultMessage: JSON.stringify(response), 
          submit_spinner: false
        })
      },
      onApproval: async (response) => {
        console.log("On Approval", response)
        // send refund email 
        rthis.setState({
          result: "Approved",
          resultMessage: JSON.stringify(response), 
          submit_spinner: false
        })

        await axios.patch(`${end_point('transactions')}/transactions`, {
          "selectedItem": this.props.tx.selectedItem,
          "amount": document.getElementById("amount").value,
          "refund": true,
          "token": this.state.jwt
        }).then(response => {
          console.log("Back from sending email", response)
          rthis.props.loadPage()
        })
      }
    }

    var paymentData = {
      ssl_transaction_type: "ccreturn",
      ssl_txn_auth_token: this.state.token,
      ssl_txn_id: this.props.tx.selectedItem.payment_gateway.receipt.ssl_txn_id, 
      ssl_amount: +document.getElementById("amount").value
    }
    console.log('payment data',paymentData)
    window.ConvergeEmbeddedPayment.pay(paymentData, resultFunctions)
  }

  handleNextStep = async () => {
    if (document.getElementById("amount").value === "") {
      window.alert("Please enter an amount")
    } else {
      this.setState({
        disable: true,
        next_spinner: true
      })
      const amount = document.getElementById("amount").value;
      const response = await axios.post(`${end_point('payments')}/${this.props.tx.selectedItem.organization_id}?refund=true&amount=${amount}`, {headers: {}})
      console.log("RESPONSE FROM TOKEN=",response.data)
      this.setState({
        token: response.data,
        next_spinner:false
      })
    }
    
  }

  renderConfirm() {
    return (
      <div>
        <Row>
          <Col sm={4}>
            Click Submit to confirm this refund.
            <br/><br/>
          </Col>
        </Row>
        <Row> 
          {
            this.state.submit_spinner ?
              <Col sm={2}>
                <div className="enrolment-loader"></div>
              </Col>
              :
              <Fragment>
                <Col lg={2} sm={2}>
                  <Button className="cancel-option" type="button" onClick={()=> this.cancelRefund()}>CANCEL</Button>
                </Col>                
                <Col lg={3} sm={2}>
                  <Button className="button2" type="button" onClick={()=> this.handleSubmit()}>Submit</Button>
                </Col>      
              </Fragment>
          }     
          <br/>
        </Row>
      </div>
    )
  }

  renderApprove() {
    return (
      <Row>
        <Col sm={12}>
          ${document.getElementById("amount").value} has been refunded. Update your transaction notes to keep your records complete.&nbsp;
          <img src="smiley.png" style={{ height: '30px', width: '30px'}} />&nbsp;
          <br/><br/>
        </Col>
      </Row>
    )
  }

  renderFail() {
    return (
      <Row>
        <Col sm={4}>
          The refund has failed.
          <br/><br/>
        </Col>
      </Row>
    )
  }

  render() {
    const { selectedItem, organization_merch } = this.props.tx
    const { disable } = this.state
    const paymentCredentials = this.props.payment_credentials || {}
    return(
        <div className={"modal-formfields"} style={{marginTop: "20px"}}>
          <div className={"row"}>
            <div className={"col-md-8 col-md-offset-2"}>
              <div className={"opaque-grey transaction-details"}>
                <h2 className={"pagetitle"}>Visit your Converge account to refund this transaction.</h2>
                <ul>
                  <li>AID: {paymentCredentials.ssl_merchant_id || 'Not available'}</li>
                  <li>UID: {paymentCredentials.ssl_user_id || 'Not available'}</li>
                </ul>
                <a href={"https://www.convergepay.com/converge-webapp/#!/login"} target={"_blank"} className={"button2 btn btn-default"}>Go to converge</a>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default Refund
